import React from 'react'
import moment from 'moment'

import Divider from '../../../../atoms/Divider'

import { useBreakpoint } from '../../../../../providers/BreakpointProvider'
import useStyles from './styles'

const SessionDivider = ({
  isEnd,
  date,
  group,
  createdUser,
  convo,
  children
}) => {
  const { isSmall } = useBreakpoint()

  const formattedDate = moment(date).format('MMM D, h:mm A')

  const classes = useStyles()

  const getMessage = React.useCallback(() => {
    if (group) {
      if (createdUser) {
        if (!isEnd) {
          return (
            <div>
              <span
                style={{
                  color: 'rgba(127,132,135, 0.5)',
                  marginRight: '0.25rem'
                }}
              >
                {formattedDate}
              </span>{' '}
              Group conversation created by {createdUser}
            </div>
          )
        }
      } else {
        return (
          <div>
            <span
              style={{
                color: 'rgba(127,132,135, 0.5)',
                marginRight: '0.25rem'
              }}
            >
              {formattedDate}
            </span>{' '}
            Group chat conversation {`${isEnd ? 'ended' : 'started'}`}
          </div>
        )
      }
    } else {
      if (createdUser) {
        if (!isEnd && convo?.owner_id) {
          return (
            <div>
              <span
                style={{
                  color: 'rgba(127,132,135, 0.5)',
                  marginRight: '0.25rem'
                }}
              >
                {formattedDate}
              </span>{' '}
              Client conversation created by {createdUser}
            </div>
          )
        }
      } else {
        return (
          <div>
            <span
              style={{
                color: 'rgba(127,132,135, 0.5)',
                marginRight: '0.25rem'
              }}
            >
              {formattedDate}
            </span>{' '}
            Live chat conversation {`${isEnd ? 'ended' : 'started'}`}
          </div>
        )
      }
    }
  }, [group, formattedDate, isEnd, createdUser, convo])

  return isSmall ? (
    <>
      <div className={classes.start}>{getMessage()}</div>

      {children}
    </>
  ) : (
    <Divider>
      <div className={classes.start}>{getMessage()}</div>

      {children}
    </Divider>
  )
}

export default SessionDivider
